import template from './reportMap.html';
import controller from './reportMap.controller';
import './reportMap.scss';

let reportMapComponent = {
  bindings: {
      resolve: '<',
      close: '&',
      dismiss: '&'
  },
  template,
  controller,
  controllerAs: "vm"
};

export default reportMapComponent;



// WEBPACK FOOTER //
// ./client/app/common/reportMap/reportMap.component.js